import { render, staticRenderFns } from "./CoursePresents.vue?vue&type=template&id=42946e22&scoped=true&"
import script from "./CoursePresents.vue?vue&type=script&lang=js&"
export * from "./CoursePresents.vue?vue&type=script&lang=js&"
import style0 from "./CoursePresents.vue?vue&type=style&index=0&id=42946e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42946e22",
  null
  
)

export default component.exports